export const nightLifeData = [
    {
        "type": "restaurant",
        "info": {
            "resId": 20996449,
            "name": "KLING",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/9/20996449/76db63ab6cca59adc9f1fea4f7823b5a_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/9/20996449/76db63ab6cca59adc9f1fea4f7823b5a_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/9/20996449/650336a8049763ebfe6710a4902ba9c1_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.3",
                "rating_text": "4.3",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "677",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.3",
                        "reviewCount": "676",
                        "reviewTextSmall": "676 Reviews",
                        "subtext": "676 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.3",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "",
                        "reviewCount": "1",
                        "reviewTextSmall": "1 Reviews",
                        "subtext": "Not enough Delivery Reviews",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "grey",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "grey",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹1,500 for two"
            },
            "cfo": {
                "text": "₹600 for one"
            },
            "locality": {
                "name": "Church Street, Bangalore",
                "address": "27, Ground Floor, Sattva Auro, Shanthala Nagar, Ashok Nagar, Church Street, Bangalore",
                "localityUrl": "bangalore/church-street-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/continental/",
                    "name": "Continental"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzhcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/european/",
                    "name": "European"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/asian/",
                    "name": "Asian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/south-indian/",
                    "name": "South Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODNcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/sea-food/",
                    "name": "Seafood"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹1,500 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/bangalore/kling-church-street-bangalore/info",
            "clickActionDeeplink": ""
        },
        "distance": "915 m",
        "isPromoted": true,
        "promotedText": "Promoted",
        "trackingData": [
            {
                "table_name": "jadtracking",
                "payload": "{\"banner_id\":\"6301475\",\"bzone\":\"0\",\"campaign_id\":\"15249905\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"4\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"20996449\",\"isNewAd\":\"34\",\"ad_position\":\"10\",\"slider_position\":\"10\",\"slider_sequence\":\"10\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":42,\\\"boosted_rank\\\":10,\\\"subzone_id\\\":5103,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.030032\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"distance\\\":\\\"1.1086797714233398\\\",\\\"organic_ctr\\\":\\\"0.007724\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"1125\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0.46128561554412106\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"cost_per_unit\\\":\\\"0.5089940048047529\\\",\\\"distance\\\":\\\"0.897818152723222\\\",\\\"organic_ctr\\\":\\\"0.00895313741064337\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.058485038711027414\\\"},\\\"search_id\\\":\\\"0066deab-d41b-486f-9abf-f7526027bf6f\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.4173626996658705}\",\"subzone_id\":\"5103\"}",
                "event_names": {
                    "tap": "{\"action\":\"click\"}",
                    "impression": "{\"action\":\"impression\"}",
                    "served": "{\"action\":\"serve\"}"
                }
            },
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20996449\",\"element_type\":\"listing\",\"rank\":10,\"metadata\":{\"is_ad\":\"true\"}}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 21538950,
            "name": "Jollygunj",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/0/21538950/69e5703bfb3ba293da514f2d7e1ced2b_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/0/21538950/69e5703bfb3ba293da514f2d7e1ced2b_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": false
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "0",
                "rating_text": "NEW",
                "rating_subtitle": "Not rated",
                "rating_color": "CBCBCB",
                "votes": "49",
                "subtext": "REVIEWS",
                "is_new": true
            },
            "ratingNew": {
                "newlyOpenedObj": {
                    "text": "Newly Opened",
                    "color": "#FFFFFF",
                    "bgColor": "#F4A266",
                    "bgColorV2": {
                        "type": "green",
                        "tint": "100"
                    },
                    "subtitle": "OUTLET",
                    "ratingV2": "New"
                },
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "",
                        "reviewCount": "49",
                        "reviewTextSmall": "49 Reviews",
                        "subtext": "Does not offer Dining",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDining": true
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "",
                        "reviewCount": "0",
                        "reviewTextSmall": "0 Reviews",
                        "subtext": "Not enough Delivery Reviews",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "grey",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "grey",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹1,000 for two"
            },
            "cfo": {
                "text": "₹400 for one"
            },
            "locality": {
                "name": "JP Nagar, Bangalore",
                "address": "3rd and 4th Floor, Jollygunj, 17/A, 15th Cross, Outer Ring Road, 3rd Phase, JP Nagar, Karnataka, JP Nagar, Bangalore",
                "localityUrl": "bangalore/jp-nagar-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjI3XCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/bar-food/",
                    "name": "Bar Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/bengali/",
                    "name": "Bengali"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/biryani/",
                    "name": "Biryani"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc4XCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/kebab/",
                    "name": "Kebab"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcxXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/finger-food/",
                    "name": "Finger Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/desserts/",
                    "name": "Desserts"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyNFwiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/wraps/",
                    "name": "Wraps"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹1,000 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/bangalore/jollygunj-jp-nagar-bangalore/info",
            "clickActionDeeplink": ""
        },
        "distance": "7.1 km",
        "isPromoted": true,
        "promotedText": "Promoted",
        "trackingData": [
            {
                "table_name": "jadtracking",
                "payload": "{\"banner_id\":\"6668420\",\"bzone\":\"0\",\"campaign_id\":\"15622045\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"4\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"21538950\",\"isNewAd\":\"34\",\"ad_position\":\"11\",\"slider_position\":\"11\",\"slider_sequence\":\"11\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":358,\\\"boosted_rank\\\":11,\\\"subzone_id\\\":5103,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.052497\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"distance\\\":\\\"7.101937294006348\\\",\\\"organic_ctr\\\":\\\"0.020914\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"1082\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0.8063435988019354\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"cost_per_unit\\\":\\\"0.7507282062706687\\\",\\\"distance\\\":\\\"0.11258227630298273\\\",\\\"organic_ctr\\\":\\\"0.0508594122319301\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.05623561414521867\\\"},\\\"search_id\\\":\\\"0066deab-d41b-486f-9abf-f7526027bf6f\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.417345945785902}\",\"subzone_id\":\"5103\"}",
                "event_names": {
                    "tap": "{\"action\":\"click\"}",
                    "impression": "{\"action\":\"impression\"}",
                    "served": "{\"action\":\"serve\"}"
                }
            },
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"21538950\",\"element_type\":\"listing\",\"rank\":11,\"metadata\":{\"is_ad\":\"true\"}}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 60228,
            "name": "Tiger Trail - Royal Orchid Hotel",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/8/60228/4c4972b5d84be985e8a4a475426964a4_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/chains/8/60228/4c4972b5d84be985e8a4a475426964a4_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/8/60228/a40b97e4d70be011e63872a704ce7263_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.3",
                "rating_text": "4.3",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "1,847",
                "subtext": "REVIEW",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.3",
                        "reviewCount": "1,622",
                        "reviewTextSmall": "1,622 Reviews",
                        "subtext": "1,622 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.3",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.4",
                        "reviewCount": "225",
                        "reviewTextSmall": "225 Reviews",
                        "subtext": "225 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.4",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.4"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.1"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.7"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹2,200 for two"
            },
            "cfo": {
                "text": "₹900 for one"
            },
            "locality": {
                "name": "Royal Orchid Hotel,  Old Airport Road, Bangalore",
                "address": "1, Royal Orchid Hotel, Golf Arcade, HAL, Old Airport Road, Bangalore",
                "localityUrl": "bangalore/restaurants/in/royal-orchid-hotel-old-airport-road"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/mughlai/",
                    "name": "Mughlai"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/desserts/",
                    "name": "Desserts"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹2,200 for two"
            }
        },
        "order": [],
        "gold": {
            "instant": 25,
            "welcome_offer": false,
            "gold_offer": false,
            "text": "Flat",
            "offerValue": "25% OFF",
            "isGoldIcon": false
        },
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/bangalore/tiger-trail-royal-orchid-hotel-airport-road-bangalore/info",
            "clickActionDeeplink": ""
        },
        "distance": "5.3 km",
        "isPromoted": true,
        "promotedText": "Promoted",
        "trackingData": [
            {
                "table_name": "jadtracking",
                "payload": "{\"banner_id\":\"5764428\",\"bzone\":\"0\",\"campaign_id\":\"14704547\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"4\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"60228\",\"isNewAd\":\"34\",\"ad_position\":\"12\",\"slider_position\":\"12\",\"slider_sequence\":\"12\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":343,\\\"boosted_rank\\\":12,\\\"subzone_id\\\":5103,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.045666\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"distance\\\":\\\"5.490638256072998\\\",\\\"organic_ctr\\\":\\\"0.01487\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"26\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0.7014207818139928\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"cost_per_unit\\\":\\\"0.6772267505763105\\\",\\\"distance\\\":\\\"0.32369448155348857\\\",\\\"organic_ctr\\\":\\\"0.03165687053216839\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.000993931784892237\\\"},\\\"search_id\\\":\\\"0066deab-d41b-486f-9abf-f7526027bf6f\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.41182018335251885}\",\"subzone_id\":\"5103\"}",
                "event_names": {
                    "tap": "{\"action\":\"click\"}",
                    "impression": "{\"action\":\"impression\"}",
                    "served": "{\"action\":\"serve\"}"
                }
            },
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"60228\",\"element_type\":\"listing\",\"rank\":12,\"metadata\":{\"is_ad\":\"true\"}}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 55788,
            "name": "Smoke House Deli",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/8/55788/6ee515d968849569c86251e6c97fb1e5_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/8/55788/6ee515d968849569c86251e6c97fb1e5_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/7/54397/d8934a07fb7716a1acb522205cbe7c9c_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.5",
                "rating_text": "4.5",
                "rating_subtitle": "Excellent",
                "rating_color": "3F7E00",
                "votes": "7,622",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.6",
                        "reviewCount": "3,965",
                        "reviewTextSmall": "3,965 Reviews",
                        "subtext": "3,965 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.6",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "800"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.5",
                        "reviewCount": "3,657",
                        "reviewTextSmall": "3,657 Reviews",
                        "subtext": "3,657 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.5",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "800"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "800"
                                    },
                                    "rating": "4.5"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.3"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.9"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹1,800 for two"
            },
            "cfo": {
                "text": "₹750 for one"
            },
            "locality": {
                "name": "Lavelle Road, Bangalore",
                "address": "52/ 53, Ground Floor, Lavelle Road, Bangalore",
                "localityUrl": "bangalore/lavelle-road-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/continental/",
                    "name": "Continental"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/italian/",
                    "name": "Italian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTkzXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/bbq/",
                    "name": "BBQ"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/fast-food/",
                    "name": "Fast Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjMzXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/ice-cream/",
                    "name": "Ice Cream"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/salad/",
                    "name": "Salad"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/desserts/",
                    "name": "Desserts"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹1,800 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/SmokeHouseDeli-LavelleRoad/info",
            "clickActionDeeplink": ""
        },
        "distance": "169 m",
        "isPromoted": true,
        "promotedText": "Promoted",
        "trackingData": [
            {
                "table_name": "jadtracking",
                "payload": "{\"banner_id\":\"6767843\",\"bzone\":\"0\",\"campaign_id\":\"15724706\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"4\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"55788\",\"isNewAd\":\"34\",\"ad_position\":\"13\",\"slider_position\":\"13\",\"slider_sequence\":\"13\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":35,\\\"boosted_rank\\\":13,\\\"subzone_id\\\":5103,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.027567\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"distance\\\":\\\"0.3732486069202423\\\",\\\"organic_ctr\\\":\\\"0.116751\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"68\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0.4234237001766378\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"cost_per_unit\\\":\\\"0.3650064481174365\\\",\\\"distance\\\":\\\"0.9941742550314135\\\",\\\"organic_ctr\\\":\\\"0.35534551231135825\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.003191044151496129\\\"},\\\"search_id\\\":\\\"0066deab-d41b-486f-9abf-f7526027bf6f\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.40178411590039764}\",\"subzone_id\":\"5103\"}",
                "event_names": {
                    "tap": "{\"action\":\"click\"}",
                    "impression": "{\"action\":\"impression\"}",
                    "served": "{\"action\":\"serve\"}"
                }
            },
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"55788\",\"element_type\":\"listing\",\"rank\":13,\"metadata\":{\"is_ad\":\"true\"}}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 21097840,
            "name": "Ouzo By Fire",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/0/21097840/2ab98a844d1426631cc838a5db64156c_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/0/21097840/2ab98a844d1426631cc838a5db64156c_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/0/21097840/c997c8006472c8d3e87c3f782034d3fd_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.1",
                "rating_text": "4.1",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "336",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.5",
                        "reviewCount": "324",
                        "reviewTextSmall": "324 Reviews",
                        "subtext": "324 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.5",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "800"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "",
                        "reviewCount": "12",
                        "reviewTextSmall": "12 Reviews",
                        "subtext": "Not enough Delivery Reviews",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "500"
                                    },
                                    "rating": "3.4"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "grey",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "grey",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹1,000 for two"
            },
            "cfo": {
                "text": "₹400 for one"
            },
            "locality": {
                "name": "Indiranagar, Bangalore",
                "address": "655, Viansh Building, 1st Stage, 100 Feet Road, Indiranagar, Bangalore",
                "localityUrl": "bangalore/indiranagar-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDdcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/goan/",
                    "name": "Goan"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzJcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/mangalorean/",
                    "name": "Mangalorean"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹1,000 for two"
            }
        },
        "order": [],
        "gold": {
            "instant": 10,
            "welcome_offer": false,
            "gold_offer": false,
            "text": "Flat",
            "offerValue": "10% OFF",
            "isGoldIcon": false
        },
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/bangalore/ouzo-by-fire-indiranagar-bangalore/info",
            "clickActionDeeplink": ""
        },
        "distance": "4.8 km",
        "isPromoted": true,
        "promotedText": "Promoted",
        "trackingData": [
            {
                "table_name": "jadtracking",
                "payload": "{\"banner_id\":\"6840363\",\"bzone\":\"0\",\"campaign_id\":\"15800251\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"4\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"21097840\",\"isNewAd\":\"34\",\"ad_position\":\"14\",\"slider_position\":\"14\",\"slider_sequence\":\"14\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":54,\\\"boosted_rank\\\":14,\\\"subzone_id\\\":5103,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.041331\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"distance\\\":\\\"4.9956488609313965\\\",\\\"organic_ctr\\\":\\\"0.017423\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"175\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0.6348360340987635\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"cost_per_unit\\\":\\\"0.6786107523038283\\\",\\\"distance\\\":\\\"0.38854793229344986\\\",\\\"organic_ctr\\\":\\\"0.03976806989674345\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.008788449466415568\\\"},\\\"search_id\\\":\\\"0066deab-d41b-486f-9abf-f7526027bf6f\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.4016938126577122}\",\"subzone_id\":\"5103\"}",
                "event_names": {
                    "tap": "{\"action\":\"click\"}",
                    "impression": "{\"action\":\"impression\"}",
                    "served": "{\"action\":\"serve\"}"
                }
            },
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"21097840\",\"element_type\":\"listing\",\"rank\":14,\"metadata\":{\"is_ad\":\"true\"}}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 20916896,
            "name": "Jamming Goat 3.0",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/6/20916896/fefe6946d4ab398fb07391083aed7bc4_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/6/20916896/fefe6946d4ab398fb07391083aed7bc4_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/6/20916896/00621490a107fecdc01742894d7d9684_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.2",
                "rating_text": "4.2",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "912",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.3",
                        "reviewCount": "910",
                        "reviewTextSmall": "910 Reviews",
                        "subtext": "910 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.3",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.1",
                        "reviewCount": "2",
                        "reviewTextSmall": "2 Reviews",
                        "subtext": "2 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.1",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.1"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "500"
                                    },
                                    "rating": "3.4"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "500"
                                    },
                                    "rating": "3.3"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹1,500 for two"
            },
            "cfo": {
                "text": "₹600 for one"
            },
            "locality": {
                "name": "Indiranagar, Bangalore",
                "address": "1st & 2nd Floor, HAL Second Stage, 100 Feet Road, Indiranagar, Bangalore",
                "localityUrl": "bangalore/indiranagar-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/south-indian/",
                    "name": "South Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/asian/",
                    "name": "Asian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/thai/",
                    "name": "Thai"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/continental/",
                    "name": "Continental"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/north-indian/",
                    "name": "North Indian"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹1,500 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/bangalore/jamming-goat-3-0-indiranagar-bangalore/info",
            "clickActionDeeplink": ""
        },
        "distance": "4.9 km",
        "isPromoted": true,
        "promotedText": "Promoted",
        "trackingData": [
            {
                "table_name": "jadtracking",
                "payload": "{\"banner_id\":\"6762172\",\"bzone\":\"0\",\"campaign_id\":\"15719009\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"4\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"20916896\",\"isNewAd\":\"34\",\"ad_position\":\"15\",\"slider_position\":\"15\",\"slider_sequence\":\"15\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":293,\\\"boosted_rank\\\":15,\\\"subzone_id\\\":5103,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.041816\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"distance\\\":\\\"5.107170581817627\\\",\\\"organic_ctr\\\":\\\"0.09183\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"428\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0.6422855387451041\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"cost_per_unit\\\":\\\"0.6644259263318989\\\",\\\"distance\\\":\\\"0.3739363698985387\\\",\\\"organic_ctr\\\":\\\"0.2761683876092137\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.022023435865243773\\\"},\\\"search_id\\\":\\\"0066deab-d41b-486f-9abf-f7526027bf6f\\\",\\\"section_name\\\":\\\"featured\\\",\\\"total_score\\\":0.3992511027366632}\",\"subzone_id\":\"5103\"}",
                "event_names": {
                    "tap": "{\"action\":\"click\"}",
                    "impression": "{\"action\":\"impression\"}",
                    "served": "{\"action\":\"serve\"}"
                }
            },
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20916896\",\"element_type\":\"listing\",\"rank\":15,\"metadata\":{\"is_ad\":\"true\"}}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 20973911,
            "name": "Mykos Craft Kitchen & Bar",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/1/20973911/9349036bcfa3e7b61cffe0e2d182804f_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/1/20973911/9349036bcfa3e7b61cffe0e2d182804f_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": false
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.4",
                "rating_text": "4.4",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "4,620",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": {
                    "text": "Newly Opened",
                    "color": "#FFFFFF",
                    "bgColor": "#F4A266",
                    "bgColorV2": {
                        "type": "green",
                        "tint": "100"
                    },
                    "subtitle": "OUTLET",
                    "ratingV2": "New"
                },
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.4",
                        "reviewCount": "4,617",
                        "reviewTextSmall": "4,617 Reviews",
                        "subtext": "4,617 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.4",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "",
                        "reviewCount": "3",
                        "reviewTextSmall": "3 Reviews",
                        "subtext": "Not enough Delivery Reviews",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDelivery": true,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "grey",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "grey",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹1,500 for two"
            },
            "cfo": {
                "text": "₹600 for one"
            },
            "locality": {
                "name": "Bannerghatta Road, Bangalore",
                "address": "4th Floor, SRK Towers, Bannerghatta Road, Bangalore",
                "localityUrl": "bangalore/bannerghatta-road-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/continental/",
                    "name": "Continental"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/italian/",
                    "name": "Italian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/mediterranean/",
                    "name": "Mediterranean"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTcyXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/south-american/",
                    "name": "South American"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc3XCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/sushi/",
                    "name": "Sushi"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹1,500 for two"
            }
        },
        "order": [],
        "gold": {
            "instant": 10,
            "welcome_offer": false,
            "gold_offer": false,
            "text": "Flat",
            "offerValue": "10% OFF",
            "isGoldIcon": false
        },
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/bangalore/mykos-craft-kitchen-bar-bannerghatta-road-bangalore/info",
            "clickActionDeeplink": ""
        },
        "distance": "8.2 km",
        "isPromoted": true,
        "promotedText": "Promoted",
        "trackingData": [
            {
                "table_name": "jadtracking",
                "payload": "{\"banner_id\":\"6376192\",\"bzone\":\"0\",\"campaign_id\":\"15326752\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"4\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"20973911\",\"isNewAd\":\"34\",\"ad_position\":\"16\",\"slider_position\":\"16\",\"slider_sequence\":\"16\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":286,\\\"boosted_rank\\\":16,\\\"subzone_id\\\":5103,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.050491\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"distance\\\":\\\"8.179015159606934\\\",\\\"organic_ctr\\\":\\\"0.023533\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"698\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"1\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"cost_per_unit\\\":\\\"1\\\",\\\"distance\\\":\\\"0.18261245693536676\\\",\\\"organic_ctr\\\":\\\"0.12583685188312782\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.03554229480737019\\\"},\\\"search_id\\\":\\\"0066deab-d41b-486f-9abf-f7526027bf6f\\\",\\\"section_name\\\":\\\"more\\\",\\\"total_score\\\":0.5365224919313009}\",\"subzone_id\":\"5103\"}",
                "event_names": {
                    "tap": "{\"action\":\"click\"}",
                    "impression": "{\"action\":\"impression\"}",
                    "served": "{\"action\":\"serve\"}"
                }
            },
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20973911\",\"element_type\":\"listing\",\"rank\":16,\"metadata\":{\"is_ad\":\"true\"}}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 18627369,
            "name": "Biergarten",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/9/18627369/5d8c14870df6a4d9189959e4ebaced77_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/9/18627369/5d8c14870df6a4d9189959e4ebaced77_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/9/18627369/274c21a0d861ef695d79d6db85c7bc8d_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.5",
                "rating_text": "4.5",
                "rating_subtitle": "Excellent",
                "rating_color": "3F7E00",
                "votes": "23.2K",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.6",
                        "reviewCount": "22.2K",
                        "reviewTextSmall": "22.2K Reviews",
                        "subtext": "22.2K Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.6",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "800"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.4",
                        "reviewCount": "988",
                        "reviewTextSmall": "988 Reviews",
                        "subtext": "988 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.4",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.4"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.2"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "500"
                                    },
                                    "rating": "3.4"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹2,500 for two"
            },
            "cfo": {
                "text": "₹1,000 for one"
            },
            "locality": {
                "name": "Koramangala 5th Block, Bangalore",
                "address": "Appek Building, 4th B Cross Road, Koramangala Industrial Layout, Koramangala 5th Block, Bangalore",
                "localityUrl": "bangalore/koramangala-5th-block-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/continental/",
                    "name": "Continental"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzhcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/european/",
                    "name": "European"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTkzXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/bbq/",
                    "name": "BBQ"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/asian/",
                    "name": "Asian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹2,500 for two"
            }
        },
        "order": [],
        "gold": {
            "instant": 15,
            "welcome_offer": false,
            "gold_offer": false,
            "text": "Flat",
            "offerValue": "15% OFF",
            "isGoldIcon": false
        },
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/bangalore/biergarten-koramangala-5th-block/info",
            "clickActionDeeplink": ""
        },
        "distance": "4.6 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18627369\",\"element_type\":\"listing\",\"rank\":17}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 20540040,
            "name": "Magique",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/0/20540040/212506e1d8f38dd0d9697ce408faaacf_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/0/20540040/212506e1d8f38dd0d9697ce408faaacf_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/0/20540040/85e03205173e5b6a317c3e53acc991c4_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.0",
                "rating_text": "4.0",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "5,475",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.0",
                        "reviewCount": "5,465",
                        "reviewTextSmall": "5,465 Reviews",
                        "subtext": "5,465 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.0",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "",
                        "reviewCount": "10",
                        "reviewTextSmall": "10 Reviews",
                        "subtext": "Not enough Delivery Reviews",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "grey",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "grey",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹1,700 for two"
            },
            "cfo": {
                "text": "₹700 for one"
            },
            "locality": {
                "name": "Koramangala 6th Block, Bangalore",
                "address": "Plot 36, 100 Feet Road, Near SJR Junction, Koramangala 6th Block, Bangalore",
                "localityUrl": "bangalore/koramangala-6th-block-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/asian/",
                    "name": "Asian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxOFwiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/modern-indian/",
                    "name": "Modern Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/continental/",
                    "name": "Continental"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/italian/",
                    "name": "Italian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc3XCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/sushi/",
                    "name": "Sushi"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/desserts/",
                    "name": "Desserts"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹1,700 for two"
            }
        },
        "order": [],
        "gold": {
            "instant": 10,
            "welcome_offer": false,
            "gold_offer": false,
            "text": "Flat",
            "offerValue": "10% OFF",
            "isGoldIcon": false
        },
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/bangalore/magique-koramangala-6th-block-bangalore/info",
            "clickActionDeeplink": ""
        },
        "distance": "4.9 km",
        "isPromoted": true,
        "promotedText": "Promoted",
        "trackingData": [
            {
                "table_name": "jadtracking",
                "payload": "{\"banner_id\":\"5962191\",\"bzone\":\"0\",\"campaign_id\":\"14903174\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"4\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"20540040\",\"isNewAd\":\"34\",\"ad_position\":\"18\",\"slider_position\":\"18\",\"slider_sequence\":\"18\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":287,\\\"boosted_rank\\\":18,\\\"subzone_id\\\":5103,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.042545\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"distance\\\":\\\"5.071981906890869\\\",\\\"organic_ctr\\\":\\\"0.014292\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"629\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0.8426254183913965\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"cost_per_unit\\\":\\\"0.8135640757345309\\\",\\\"distance\\\":\\\"0.5137949458708162\\\",\\\"organic_ctr\\\":\\\"0.06340820807296063\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.03193048576214405\\\"},\\\"search_id\\\":\\\"0066deab-d41b-486f-9abf-f7526027bf6f\\\",\\\"section_name\\\":\\\"more\\\",\\\"total_score\\\":0.5197124983293409}\",\"subzone_id\":\"5103\"}",
                "event_names": {
                    "tap": "{\"action\":\"click\"}",
                    "impression": "{\"action\":\"impression\"}",
                    "served": "{\"action\":\"serve\"}"
                }
            },
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20540040\",\"element_type\":\"listing\",\"rank\":18,\"metadata\":{\"is_ad\":\"true\"}}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 50975,
            "name": "The 13th Floor",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/5/50975/2269507710b2895cf68419f9830bd126_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/5/50975/2269507710b2895cf68419f9830bd126_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/5/50975/cd608791726c4ffe6e6f5e02f422b829_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.5",
                "rating_text": "4.5",
                "rating_subtitle": "Excellent",
                "rating_color": "3F7E00",
                "votes": "6,585",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.3",
                        "reviewCount": "6,268",
                        "reviewTextSmall": "6,268 Reviews",
                        "subtext": "6,268 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.3",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.7",
                        "reviewCount": "317",
                        "reviewTextSmall": "317 Reviews",
                        "subtext": "317 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.7",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "800"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "800"
                                    },
                                    "rating": "4.7"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.3"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.2"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹2,500 for two"
            },
            "cfo": {
                "text": "₹1,000 for one"
            },
            "locality": {
                "name": "Barton Centre, Bangalore",
                "address": "84/142, 12th, 13th Floor, Barton Center, MG Road, Bangalore",
                "localityUrl": "bangalore/restaurants/in/barton-centre"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/asian/",
                    "name": "Asian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc4XCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/kebab/",
                    "name": "Kebab"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/salad/",
                    "name": "Salad"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/beverages/",
                    "name": "Beverages"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/desserts/",
                    "name": "Desserts"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹2,500 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/bangalore/the-13th-floor-mg-road-bangalore/info",
            "clickActionDeeplink": ""
        },
        "distance": "1.1 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"50975\",\"element_type\":\"listing\",\"rank\":19}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 20275310,
            "name": "Miso Sexy",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/0/20275310/a99ba39ea562a436c044edd163ede6dc_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/0/20275310/a99ba39ea562a436c044edd163ede6dc_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": false
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.2",
                "rating_text": "4.2",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "6,906",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.4",
                        "reviewCount": "6,879",
                        "reviewTextSmall": "6,879 Reviews",
                        "subtext": "6,879 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.4",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "",
                        "reviewCount": "27",
                        "reviewTextSmall": "27 Reviews",
                        "subtext": "Not enough Delivery Reviews",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "grey",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "grey",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹1,800 for two"
            },
            "cfo": {
                "text": "₹750 for one"
            },
            "locality": {
                "name": "Indiranagar, Bangalore",
                "address": "963, Doopanahalli, HAL 2nd Stage, 12th Main Road, Indiranagar, Bangalore",
                "localityUrl": "bangalore/indiranagar-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNjBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/japanese/",
                    "name": "Japanese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc3XCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/sushi/",
                    "name": "Sushi"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹1,800 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/bangalore/miso-sexy-indiranagar-bangalore/info",
            "clickActionDeeplink": ""
        },
        "distance": "4.7 km",
        "isPromoted": true,
        "promotedText": "Promoted",
        "trackingData": [
            {
                "table_name": "jadtracking",
                "payload": "{\"banner_id\":\"6775264\",\"bzone\":\"0\",\"campaign_id\":\"15732128\",\"category_id\":\"1\",\"location_type\":\"city\",\"location_id\":\"4\",\"display_page\":\"dineout_home\",\"entity_type\":\"RESTAURANT\",\"entity_id\":\"20275310\",\"isNewAd\":\"34\",\"ad_position\":\"20\",\"slider_position\":\"20\",\"slider_sequence\":\"20\",\"creative_id\":\"0\",\"collection_id\":\"0\",\"data\":\"{\\\"type\\\":\\\"boost\\\",\\\"original_rank\\\":12,\\\"boosted_rank\\\":20,\\\"subzone_id\\\":5103,\\\"ordering_parameter_value\\\":{\\\"ads_ctr\\\":\\\"0.040393\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"distance\\\":\\\"4.890604019165039\\\",\\\"organic_ctr\\\":\\\"0.021011\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"popularity_score_source\\\":\\\"default\\\",\\\"target_left\\\":\\\"31\\\"},\\\"ordering_parameter_normalised_value\\\":{\\\"ads_ctr\\\":\\\"0.8000039611019785\\\",\\\"cost_for_two_ctr\\\":\\\"0\\\",\\\"cost_per_unit\\\":\\\"0.6896497749307864\\\",\\\"distance\\\":\\\"0.5331282376025299\\\",\\\"organic_ctr\\\":\\\"0.10879918932612731\\\",\\\"popularity_score\\\":\\\"0\\\",\\\"target_left\\\":\\\"0.000628140703517588\\\"},\\\"search_id\\\":\\\"0066deab-d41b-486f-9abf-f7526027bf6f\\\",\\\"section_name\\\":\\\"more\\\",\\\"total_score\\\":0.49007450107690015}\",\"subzone_id\":\"5103\"}",
                "event_names": {
                    "tap": "{\"action\":\"click\"}",
                    "impression": "{\"action\":\"impression\"}",
                    "served": "{\"action\":\"serve\"}"
                }
            },
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20275310\",\"element_type\":\"listing\",\"rank\":20,\"metadata\":{\"is_ad\":\"true\"}}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 58349,
            "name": "Buff Buffet Buff",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/9/58349/9d0f9d14689815385ac91fde39ddd137_featured_v2.jpg",
                "urlWithParams": "https://b.zmtcdn.com/data/pictures/chains/9/58349/9d0f9d14689815385ac91fde39ddd137_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/9/58349/ce59da2201b571c94e07b3036464633b_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.0",
                "rating_text": "4.0",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "4,097",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.4",
                        "reviewCount": "4,060",
                        "reviewTextSmall": "4,060 Reviews",
                        "subtext": "4,060 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.4",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "3.6",
                        "reviewCount": "37",
                        "reviewTextSmall": "37 Reviews",
                        "subtext": "37 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "3.6",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.6"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "500"
                                    },
                                    "rating": "3.4"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "grey",
                                        "tint": "500"
                                    },
                                    "rating": "0.0"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹1,800 for two"
            },
            "cfo": {
                "text": "₹750 for one"
            },
            "locality": {
                "name": "BluPetal Hotel, Koramangala, Bangalore",
                "address": "60, Jyothi Nivas College Road, Koramangala 5th Block, Bangalore",
                "localityUrl": "bangalore/restaurants/in/blupetal-hotel-koramangala"
            },
            "timing": {
                "text": "Temporarily closed for delivery, will be back soon!",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/south-indian/",
                    "name": "South Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/salad/",
                    "name": "Salad"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjI3XCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/bar-food/",
                    "name": "Bar Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/bangalore/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/desserts/",
                    "name": "Desserts"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/bangalore/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹1,800 for two"
            }
        },
        "order": [],
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/bangalore/buff-buffet-buff-koramangala-5th-block/info",
            "clickActionDeeplink": ""
        },
        "distance": "4.6 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"0066deab-d41b-486f-9abf-f7526027bf6f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4300399395616063488\",\"page_type\":\"nightlife\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"58349\",\"element_type\":\"listing\",\"rank\":21}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": false,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    }
]